<template>
  <p-vue-dropdown v-bind="$attrs"
                  
                  class="p-override-dropdown">
    <template v-if="!$slots.value" #value="{ value, placeholder }">
      <div class="p-override-dropdown-value">
        <span class="value">{{ value ? value[$attrs.optionLabel] ? value[$attrs.optionLabel] : value : placeholder }}</span>
        <span class="icons">
          <a  v-if="$attrs.showClear && value"
          
              href="#"

              @click.prevent.stop="$emit('update:modelValue', null)">
            <i-icon name="cancel" />
          </a>
          <i-icon name="arrow" />
        </span>
      </div>
    </template>
  </p-vue-dropdown>
</template>

<style scoped>

  .p-override-dropdown {
    padding: 0;

    border-radius: 0;
  }
  
  .p-override-dropdown-value {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .p-override-dropdown-value:deep(.value) {
    flex: 1;

    padding-left: 10px;

    overflow: hidden;
    line-height: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .p-override-dropdown.p-dropdown-success .p-override-dropdown-value:deep(.value) {
    color: white;
  }

  .p-override-dropdown-value:deep(.icons .svg) {
    width: 15px;
    height: 15px;

    color: var(--color-success-hover);
  }

  .p-override-dropdown.p-dropdown-success .p-override-dropdown-value:deep(.icons .svg) {
    color: white;
  }

  .p-override-dropdown-value:deep(.icons > *:not(:last-child)) {
    margin-left: 10px;
  }

  .p-override-dropdown.p-dropdown-rounded {
    border-radius: 30px;
  }

  .p-override-dropdown.p-dropdown-success {
    background-color: var(--color-success);

    color: white;
  }

  .p-override-dropdown.p-inputtext--alt {
    border-color: var(--color-border-alt);
  }

</style>